var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSignUpClose = function SvgSignUpClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.333,
    d: "M14.279.708a.72.72 0 0 1 1.014 0 .72.72 0 0 1 0 1.012L9.013 8l6.28 6.28a.72.72 0 0 1 0 1.015l-.005.004a.75.75 0 0 1-.506.2.7.7 0 0 1-.51-.204l-6.28-6.282-6.28 6.282a.73.73 0 0 1-.501.205.7.7 0 0 1-.503-.205.72.72 0 0 1 0-1.014L6.987 8 .707 1.72a.72.72 0 0 1 0-1.013.72.72 0 0 1 1.013 0L8 6.988z"
  })));
};
export default SvgSignUpClose;